import { useEffect, useMemo, useState } from 'react';
import { CITY_TYPES } from './cityUtils';
import { loadCityContext } from './cityContextCache';

export function useCityContext() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [context, setContext] = useState({ bot: null, city: null, access: null });

  async function reloadContext(force = false) {
    const nextContext = await loadCityContext({ force });
    setContext(nextContext);
    return nextContext;
  }

  useEffect(() => {
    let mounted = true;
    async function bootstrap() {
      try {
        const nextContext = await reloadContext(false);
        if (!mounted) return;
        setContext(nextContext);
      } catch (err) {
        if (!mounted) return;
        setError(err.response?.data?.error || 'No se pudo cargar la ciudad');
      } finally {
        if (mounted) setLoading(false);
      }
    }

    bootstrap();
    return () => {
      mounted = false;
    };
  }, []);

  const cityTypeLabel = useMemo(() => {
    const typeId = Number(context.city?.city_type ?? -1);
    return CITY_TYPES[typeId] || 'Asentamiento';
  }, [context.city?.city_type]);

  return {
    loading,
    error,
    context,
    setContext,
    cityTypeLabel,
    reloadContext
  };
}
